export enum TABS {
  CHAT = 0,
  PARTICIPANTS = 1,
  QA = 2,
  CC = 3,
  NONE = 4, // non interactive tab used to reset emoji reaction container height
  POLLS = 5,
}

export enum TransitionState {
  ENDED = "ended",
  TRANSITIONING = "transitioning",
}
